import { render, staticRenderFns } from "./CargoGrid.vue?vue&type=template&id=0178e4e8"
import script from "./CargoGrid.vue?vue&type=script&lang=js"
export * from "./CargoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports